import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    earnMore: 'Earn more with DeFi',
    points: 'Check your points',
    explore: 'Explore',
    liquidLink: 'LiquidLink',
  },
};
